import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function JournalArticle() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  useEffect(() => { api.get(`/journal/${slug}`).then(({ data }) => setA(data)); }, [slug]);
  if (!a) return <div className="py-24 text-center text-asure-text2">Loading…</div>;
  return (
    <div className="max-w-3xl mx-auto px-5 md:px-8 pt-10 pb-24">
      <Link to="/journal" className="text-xs text-asure-text2 hover:text-asure-forest">← Journal</Link>
      <div className="eyebrow mt-6">{a.category}</div>
      <h1 className="font-display text-5xl md:text-6xl mt-3 leading-tight">{a.title}</h1>
      <img src={a.hero} alt="" className="mt-10 w-full rounded-3xl aspect-video object-cover" />
      <div className="prose mt-10 text-asure-text2 text-lg leading-relaxed">{a.body}</div>
    </div>
  );
}
